<!-- eslint-disable vue/html-self-closing -->
<template>
  <div
    class="gf-cropper"
    :class="{ '--rounded': isRoundedCrop }"
    :style="[
      isRoundedCrop ? { '--gf-cropper-br': '50%' } : { '--gf-cropper-br': '8px' },
      { '--gf-cropper-preview-c': previewColor },
      previewHasBorder
        ? { '--gf-cropper-preview-b': previewBorder + ' solid var( --gf-cropper-preview-c)' }
        : { '--gf-cropper-preview-b': 'none' }
    ]"
  >
    <div
      v-if="showPreview"
      class="gf-cropper__preview"
      :style="{ width: previewWidth }"
    >
      <img
        :src="imageSource"
        class="gf-cropper__preview-image"
      />
      <gf-dropdown
        v-if="showEditButton"
        ref="gfDropdownEditOptions"
        class="gf-cropper__cropper-dropdown"
        position="right"
        :btn-icon="editButtonIcon"
        btn-class="d-flex align-items-center gf-cropper__options-toggle btn btn-dark btn-sm"
        :no-carret="true"
      >
        <a
          class="d-flex align-items-center dropdown-item f5"
          @click="editImage"
        >
          <i class="gf-icon gf-icon-crop" />
          Редактировать
        </a>
        <a
          class="d-flex align-items-center dropdown-item f5"
          @click="uploadImage"
        >
          <i class="gf-icon gf-icon-upload" />
          <input
            ref="uploadImageInput"
            type="file"
            :name="inputName"
            :accept="allowedExtentions"
            style="display: none"
            @change="onInputUploadChange"
          />
          Сменить
          <span class="text-muted small ml-1">{{ allowedExtentions?.split(',')?.join(' ') }}</span>
        </a>
        <div class="dropdown-divider" />
        <button
          type="button"
          class="d-flex align-items-center dropdown-item f5 text-danger"
          @click="setDefaultImage"
        >
          <i class="gf-icon gf-icon-trash" />
          Удалить
        </button>
      </gf-dropdown>
    </div>

    <gf-custom-modal-window
      ref="gfCustomModalWindowCropper"
      gf-modal-data-name="userImageCropper"
      :gf-modal-header="modalTitle"
      :gf-modal-wrapper-width="modalWidth"
      @closeWithoutSubmit="setDefaultOptions"
    >
      <template #body>
        <div class="gf-cropper__editor">
          <div class="gf-cropper__image-editor">
            <div
              class="gf-cropper__image-box"
              :style="{ height: imageBoxHeight + 'px', width: imageBoxWidth + 'px' }"
            >
              <img
                id="image"
                ref="croppedImage"
                :src="cropperImageSource"
                class="gf-cropper__image"
              />
            </div>
          </div>
          <div class="gf-cropper__toolbox">
            <div class="gf-cropper__sliders">
              <div class="gf-cropper__slider">
                <i class="gf-icon gf-icon-search" />
                <input
                  v-model="zoomValue"
                  class="gf-cropper__range"
                  type="range"
                  min="0"
                  max="100"
                  step="1"
                  @input="onRangeZoomChange"
                />
                <div class="gf-cropper__range-text">
                  <span>{{ zoomValue }}%</span>
                </div>
              </div>
              <div class="gf-cropper__slider">
                <i class="gf-icon gf-icon-rotate-right" />
                <input
                  v-model="rotatationValue"
                  class="gf-cropper__range"
                  type="range"
                  min="0"
                  max="360"
                  step="1"
                  @input="onRangeRotationChange"
                />
                <div class="gf-cropper__range-text">
                  <span>{{ rotatationValue }}°</span>
                </div>
              </div>
            </div>
          </div>
          <div class="gf-cropper__footer">
            <button
              class="d-flex align-items-center btn btn-sm btn-outline-secondary"
              type="button"
              @click="resetCroperOptions"
            >
              <i class="gf-icon gf-icon-x" />
            </button>
            <button
              class="d-flex align-items-center btn btn-sm btn-outline-success"
              type="button"
              @click="submitCropperData"
            >
              <i class="gf-icon gf-icon-check" />
            </button>
          </div>
        </div>
      </template>
    </gf-custom-modal-window>
  </div>
</template>

<script>
import GfCustomModalWindow from './GfCustomModalWindow.vue';
import GfDropdown from './GfDropdown.vue';

export default {
  name: 'GfImageCropper',
  components: { GfCustomModalWindow, GfDropdown },
  props: {
    selectedImageSource: {
      type: String,
      default: null
    },
    showPreview: {
      type: Boolean,
      default: true
    },
    previewWidth: {
      type: String,
      default: 'auto'
    },
    previewColor: {
      type: String,
      default: 'var(--border-color)'
    },
    previewHasBorder: {
      type: Boolean,
      default: true
    },
    previewBorder: {
      type: String,
      default: '3px'
    },
    showEditButton: {
      type: Boolean,
      default: true
    },
    editButtonIcon: {
      type: String,
      default: 'gf-icon gf-icon-edit-square'
    },
    imageBoxHeight: {
      type: String,
      default: '400'
    },
    imageBoxWidth: {
      type: String,
      default: '400'
    },
    aspectRatio: {
      default: 1
    },
    modalWindowWidth: {
      type: String,
      default: '600'
    },
    modalTitle: {
      type: String,
      default: 'Редактировать изображение'
    },
    isRoundedCrop: {
      type: Boolean,
      default: false
    },
    inputName: {
      type: String,
      required: true
    },
    allowedExtentions: {
      type: String,
      default: '.png, .jpg, .jpeg'
    }
  },
  data() {
    return {
      imageSource: null,
      cropperImageSource: null,
      cropper: null,
      cropperOptions: {},
      rotatationValue: 0,
      zoomValue: 0,
      initialZoomValue: null,
      modalWidth: null,
      linksToInitCropper: [
        '/settings/profile',
        '/admin/user/',
        '/team/',
        '/admin/team/',
        '/company/',
        '/admin/company/'
      ],
      CropperClass: null
    };
  },
  computed: {
    getInitialZoomValue() {
      const imageData = this.cropper.getImageData();
      const zoom = imageData.width / imageData.naturalWidth;
      return zoom;
    }
  },
  mounted() {
    if (this.linksToInitCropper.find((link) => this.$route?.path.startsWith(link))) {
      this.loadCropper();
    }
    this.imageSource = this.selectedImageSource;
    this.cropperImageSource = this.selectedImageSource;
    this.modalWidth = `${this.modalWindowWidth}px`;
  },
  methods: {
    loadCropper() {
      // eslint-disable-next-line import/extensions
      import('cropperjs')
        .then((component) => {
          this.CropperClass = component.default;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    editImage() {
      if (!this.cropper) {
        this.createCropper();
      } else {
        this.$refs.gfDropdownEditOptions.close();
        this.$refs.gfCustomModalWindowCropper.openModalWindow();
      }
    },
    createCropper() {
      this.initialZoomValue = null;
      this.cropperOptions = {
        aspectRatio: parseFloat(this.aspectRatio),
        minCropBoxWidth: 256,
        minCropBoxHeight: 256,
        viewMode: 2,
        dragMode: 'move',
        background: false,
        cropBoxMovable: true,
        cropBoxesizable: true,
        autoCropArea: 1,
        zoomOnWheel: false,
        ...this.cropperOptions
      };

      this.cropper = new this.CropperClass(this.$refs.croppedImage, this.cropperOptions);
      this.$refs.gfDropdownEditOptions.close();
      this.$refs.gfCustomModalWindowCropper.openModalWindow();
    },
    onRangeRotationChange() {
      this.cropper.rotateTo(this.rotatationValue);
    },
    onRangeZoomChange() {
      if (this.initialZoomValue) {
        this.cropper.zoomTo(this.zoomValue / 100 + this.initialZoomValue);
      } else {
        this.initialZoomValue = this.getInitialZoomValue;
      }
    },
    uploadImage() {
      this.$refs.uploadImageInput.click();
    },
    onInputUploadChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.$refs.croppedImage.src = URL.createObjectURL(file);
        this.cropperImageSource = URL.createObjectURL(file);

        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = null;
          this.createCropper();
        } else {
          this.createCropper();
        }
      }
    },
    resetCroperOptions() {
      if (this.cropper) {
        this.cropper.reset();
        this.zoomValue = 0;
        this.rotatationValue = 0;
      }
    },
    setDefaultOptions() {
      if (this.cropperImageSource !== this.imageSource) {
        this.cropper.destroy();
        this.cropper = null;
        this.cropperImageSource = this.imageSource;
      } else {
        this.resetCroperOptions();
      }
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    submitCropperData() {
      let canvas;
      if (this.isRoundedCrop) {
        canvas = this.getRoundedCanvas(this.cropper.getCroppedCanvas());
      } else {
        canvas = this.cropper.getCroppedCanvas();
      }

      const result = canvas.toDataURL('image/jpeg', 0.9);
      const container = new DataTransfer();
      const fileName = `${this.inputName}.jpg`;
      const file = this.dataURLtoFile(result, fileName);

      container.items.add(file);
      this.$refs.uploadImageInput.files = container.files;
      this.imageSource = result;
      this.cropperImageSource = result;
      this.$refs.gfCustomModalWindowCropper.closeModalWindow();
    },
    getRoundedCanvas(sourceCanvas) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const { width } = sourceCanvas;
      const { height } = sourceCanvas;

      canvas.width = width;
      canvas.height = height;
      context.imageSmoothingEnabled = true;
      context.drawImage(sourceCanvas, 0, 0, width, height);
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
      context.fill();
      return canvas;
    },
    setDefaultImage(e) {
      e.target.setAttribute('disabled', '');
      this.$emit('setDefault');
    }
  }
};
</script>

<style lang="scss">
@import url('../../../../node_modules/cropperjs/src/css/cropper.css');

$this: '.gf-cropper';

#{$this} {
  --gf-cropper-br: 8px;
  --gf-cropper-preview-c: var(--border-color);
  --gf-cropper-preview-b: 5px solid var(--gf-cropper-preview-c);
}

#{$this}.--cover {
  --gf-cropper-br: 14px !important;

  @include theme.sm {
    --gf-cropper-br: 8px !important;
  }
}

#{$this}__preview {
  position: relative;

  & .dropdown-item i {
    margin-right: 4px;
  }
}

#{$this}__preview-image {
  width: 100%;
  border-radius: var(--gf-cropper-br);
  border: var(--gf-cropper-preview-b);
}

#{$this}__options-toggle {
  padding: 8px !important;
  border-color: var(--border-color);

  & i {
    font-size: 24px !important;

    @include theme.sm {
      font-size: 16px !important;
    }
  }
}

#{$this}__image-editor {
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#{$this}__image-box {
  width: 400px;
  height: 400px;
  display: block;
}

#{$this}__image {
  display: block;
  max-width: 100%;
}

#{$this}__image-actions {
  position: absolute;
  top: 90px;
  right: 32px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

#{$this}__toolbox {
  width: 100%;
  padding: 16px 0;
  border-top: 1px solid var(--border-color);
}

#{$this}__sliders {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

#{$this}__slider {
  display: flex;
  align-items: center;

  & i {
    margin-right: 20px;
    scale: 110%;
    color: var(--gf-slider-color);
  }
}

#{$this}__range {
  width: 100%;
  accent-color: var(--gf-slider-color);
}

#{$this}__range-text {
  display: flex;
  justify-content: flex-end;
  width: 45px;
}

#{$this}__range-text span {
  color: var(--gf-slider-color);
}

#{$this}__footer {
  padding-top: 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--border-color);
  gap: 12px;
}

#{$this}__cropper-dropdown {
  --gfd-minw: 100px;
  display: none;
  position: absolute !important;
  top: 10px;
  right: 10px;
  cursor: pointer;

  @include theme.sm {
    top: 83px;
    right: 20px;
  }
}

#{$this}.--rounded {
  #{$this}__cropper-dropdown {
    --gfd-minw: 100px;
    display: none;
    position: absolute;
    top: 39px;
    right: -21px;
    cursor: pointer;

    @include theme.sm {
      top: 43px;
      right: -17px;
    }
  }
}

.cropper-view-box {
  border-radius: var(--gf-cropper-br);
  outline-color: hsl(232deg 83% 64% / 75%);
}

.cropper-modal {
  opacity: 0.75;
}

.cropper-face {
  background-color: hsl(0deg 0% 100% / 75%);
}

.cropper-line {
  background-color: var(--primary);
}

.cropper-point {
  background-color: var(--primary);
}
</style>
